import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleUpMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronTriangleUpMedium"><Path d="M17.5 14.5H6.5L12 8L17.5 14.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleUpMedium;
